module.exports = __webpack_public_path__ + "static/media/line-icon.bd36a9d4.svg";